import { Outlet } from "react-router-dom";
import TopMenu from "../Menus/TopMenu";

const Moderation = () => {
    let displayComponent = (
        <>
            <TopMenu />
            <Outlet />
        </>
    );

    return displayComponent;
};

export default Moderation;
